/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ExecuteReportRequest,
  GetReportExecutionResponse,
  GetReportResponse,
  Result,
  ResultOfExecuteReportResponse,
  ResultOfUpdateReportConfigResponse,
  UpdateReportConfigRequest,
} from '../models/index';
import {
    ExecuteReportRequestFromJSON,
    ExecuteReportRequestToJSON,
    GetReportExecutionResponseFromJSON,
    GetReportExecutionResponseToJSON,
    GetReportResponseFromJSON,
    GetReportResponseToJSON,
    ResultFromJSON,
    ResultToJSON,
    ResultOfExecuteReportResponseFromJSON,
    ResultOfExecuteReportResponseToJSON,
    ResultOfUpdateReportConfigResponseFromJSON,
    ResultOfUpdateReportConfigResponseToJSON,
    UpdateReportConfigRequestFromJSON,
    UpdateReportConfigRequestToJSON,
} from '../models/index';

export interface ApiReportsIdConfigFavouritePutRequest {
    id: string;
    updateReportConfigRequest: UpdateReportConfigRequest;
    xTenantID?: number;
}

export interface ApiReportsIdExecutePostRequest {
    id: string;
    executeReportRequest: ExecuteReportRequest;
    xTenantID?: number;
}

export interface ApiReportsListGetRequest {
    xTenantID?: number;
}

export interface GetExecutionStatusRequest {
    id: string;
    xTenantID?: number;
}

/**
 * 
 */
export class ReportsApi extends runtime.BaseAPI {

    /**
     * Updates the favourite status of a report configuration. This endpoint allows users to mark a report as favourite or remove it from their favourites.
     * Update report favourite status
     */
    async apiReportsIdConfigFavouritePutRaw(requestParameters: ApiReportsIdConfigFavouritePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfUpdateReportConfigResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiReportsIdConfigFavouritePut().'
            );
        }

        if (requestParameters['updateReportConfigRequest'] == null) {
            throw new runtime.RequiredError(
                'updateReportConfigRequest',
                'Required parameter "updateReportConfigRequest" was null or undefined when calling apiReportsIdConfigFavouritePut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/reports/{id}/config/favourite`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateReportConfigRequestToJSON(requestParameters['updateReportConfigRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfUpdateReportConfigResponseFromJSON(jsonValue));
    }

    /**
     * Updates the favourite status of a report configuration. This endpoint allows users to mark a report as favourite or remove it from their favourites.
     * Update report favourite status
     */
    async apiReportsIdConfigFavouritePut(requestParameters: ApiReportsIdConfigFavouritePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfUpdateReportConfigResponse> {
        const response = await this.apiReportsIdConfigFavouritePutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Executes the specified report and returns the result. The report is executed asynchronously, and the client can poll for the result using the returned operation ID.
     * Execute report by ID
     */
    async apiReportsIdExecutePostRaw(requestParameters: ApiReportsIdExecutePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfExecuteReportResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiReportsIdExecutePost().'
            );
        }

        if (requestParameters['executeReportRequest'] == null) {
            throw new runtime.RequiredError(
                'executeReportRequest',
                'Required parameter "executeReportRequest" was null or undefined when calling apiReportsIdExecutePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/reports/{id}/execute`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ExecuteReportRequestToJSON(requestParameters['executeReportRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfExecuteReportResponseFromJSON(jsonValue));
    }

    /**
     * Executes the specified report and returns the result. The report is executed asynchronously, and the client can poll for the result using the returned operation ID.
     * Execute report by ID
     */
    async apiReportsIdExecutePost(requestParameters: ApiReportsIdExecutePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfExecuteReportResponse> {
        const response = await this.apiReportsIdExecutePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves a list of all available reports. This endpoint is used to display the available reports that can be executed, along with their details such as name, description, and parameters.
     * Get all reports
     */
    async apiReportsListGetRaw(requestParameters: ApiReportsListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetReportResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/reports/list`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetReportResponseFromJSON));
    }

    /**
     * Retrieves a list of all available reports. This endpoint is used to display the available reports that can be executed, along with their details such as name, description, and parameters.
     * Get all reports
     */
    async apiReportsListGet(requestParameters: ApiReportsListGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetReportResponse>> {
        const response = await this.apiReportsListGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves the status of a report execution by its ID. This endpoint is used to poll for the execution status after initiating a report execution. It returns the current status, any results if available, and error information if the execution failed.
     * Get report execution status
     */
    async getExecutionStatusRaw(requestParameters: GetExecutionStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetReportExecutionResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getExecutionStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/reports/{id}/status`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetReportExecutionResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves the status of a report execution by its ID. This endpoint is used to poll for the execution status after initiating a report execution. It returns the current status, any results if available, and error information if the execution failed.
     * Get report execution status
     */
    async getExecutionStatus(requestParameters: GetExecutionStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetReportExecutionResponse> {
        const response = await this.getExecutionStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
